module.exports = __webpack_public_path__ + "fonts/BarlowCondensed-Bold.544a7be.woff2";